import axios from "./Interceptors";
import { TCF_URL } from "./URLs";

const fileHeaders = {"Content-Type": "multipart/form-data"}

const calculateProductImpact = async (payload) => {
    return await axios.post(TCF_URL.CALCULATE_PRODUCT_IMPACT, payload)
}

const getStripIntent = async (payload, campaignPage) => {
    return axios.post(TCF_URL.GET_STRIPE_PAYMENT_INTENT(campaignPage), payload)
}

const getACHIntent = async (payload) => {
    return axios.post(TCF_URL.ACH_PAYMENT_INTENT, payload)
}

const stripeCheckout = async (payload, campaignPage) => {
    return axios.post(TCF_URL.STRPE_CHECKOUT(campaignPage), payload)
}

const paypalCheckout = async (payload, campaignPage) => {
    return await axios.post(TCF_URL.PAYPAL_CHECKOUT(campaignPage), payload)
}

const HBLCheckout = async (payload) => {
    return await axios.post(TCF_URL.HBL_CHECKOUT, payload)
}

const bankCheckout = async (payload, campaignPage) => {
    return await axios.post(TCF_URL.BANK_TRANSFER(campaignPage), payload, fileHeaders)
}

const uploadReceipt = async (payload) => {
    return await axios.post(TCF_URL.UPLOAD_RECEIPT, payload, fileHeaders)
}

const chequeDeposite = async (payload, campaignPage) => {
    return await axios.post(TCF_URL.CHEQUE_DEPOSITE(campaignPage), payload)
}

const getPaymentMethods = async (payload) => {
    return await axios.post(TCF_URL.GET_PAYMENT_METHODS, payload)
}

const getDonationDetails = async (transactionId) => {
    return await axios.get(TCF_URL.GET_DONATION_DETAILS(transactionId))
}

export const donationAPIs = {
    calculateProductImpact,
    getStripIntent,
    stripeCheckout,
    paypalCheckout,
    HBLCheckout,
    bankCheckout,
    uploadReceipt,
    chequeDeposite,
    getPaymentMethods,
    getDonationDetails,
    getACHIntent
}
